(() => {
  const init = (root) => {
    if (root.dataset.creatorReady) return;
    root.dataset.creatorReady = 'true';
    const select = root.querySelector('#tcv-topic');
    const budget = root.querySelector('[data-creator-budget]');
    if (!select || !budget) return;
    const update = () => {
      const visible = ['creative', 'network'].includes(select.value);
      budget.hidden = !visible;
      budget.querySelectorAll('input').forEach(input => { input.disabled = !visible; });
    };
    select.addEventListener('change', update);
    root.querySelectorAll('[data-creator-topic]').forEach(link => {
      link.addEventListener('click', () => {
        select.value = link.dataset.creatorTopic;
        update();
      });
    });
    update();
  };
  document.querySelectorAll('[data-creators]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-creators]').forEach(init);
  });
})();

